<template>
  <div>
    <div>
      <div class="text-xs-right">
        <v-btn icon @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div class="pb-4 pl-4 primary--text" style="font-size: 20px; font-weight: 500">
        {{ detaildata.campaign }}
      </div>
      <div class="pl-4">
        <v-layout row wrap class="pa-0 ma-0">
          <v-flex xs3 class="mr-3">
            <v-card style="font-weight: 500" color="#eee" class="pa-3 text-center">
              {{ items.length }} ร้าน
            </v-card>
          </v-flex>
          <v-flex xs3>
            <v-card style="font-weight: 500" color="#eee" class="pa-3 text-center">
              {{ sumPoints }} เครื่อง
            </v-card>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          hide-actions
          :pagination.sync="pagination"
          class="elevation-1"
        >
          <template #items="props">
            <tr>
              <td>
                {{ props.item.shopname }}
              </td>

              <td class="text-xs-center">
                {{ props.item.points }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
  props: ['detaildata'],
  data() {
    return {
      items: [],
      loading: false,
      modaldetail: false,
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      pagination: { rowsPerPage: -1, sortBy: '-1' },
      headers: [
        { text: 'ชื่อร้าน', value: 'shopname', align: 'center' },
        { text: 'เครื่องที่ได้รับ', value: 'points', align: 'center' }
      ]
    }
  },
  computed: {
    sumPoints() {
      if (this.items && this.items.length) {
        return this.items.reduce((a, b) => {
          return a + parseFloat(b.points)
        }, 0)
      } else return 0
    },
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    getData() {
      var data = {
        pageid: this.selectedBot.pageid,
        campaign: this.detaildata.campaign
      }

      this.loading = true
      api.getYasaleCampaignDetails(data, (err, response) => {
        this.loading = false
        this.items = response.data
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/yasale/campaign/CampaignDetail.vue